import React, { useState } from 'react';
import { Star, Minus, ChevronDown } from 'lucide-react';


const mockReviews = [
  {
    id: 1,
    name: 'Daisy Gomez',
    date: '2 months ago',
    avatar: "/testimonials/daisy.png",
    content:
      "Heather (HT) she is the best trainer coach I've ever had! She is so knowledgeable in everything training and working out! She is 4x certified! I was the person that has never worked out and she turned me into a phytness lover! Slowly but surely. She focuses on all things woman phyness! If you don't know where to start.. it is here!!! Call, text, or emai! This is your sign!!!",
    rating: 5,
  },
  {
    id: 2,
    name: 'Stephanie Nixon',
    date: '2 months ago',
    avatar: null,
    content:
      "Heather (Coach HT) is an excellent and knowledgeable trainer. I highly recommend for positive results and motivation. Check her out if you're looking for a trainer in Los Angeles",
    rating: 5,
  },
  {
    id: 3,
    name: 'Meredith Smith',
    date: '2 months ago',
    avatar: null,
    content:
      "I have been a client of Heather since 2017. From her bootcamp days to her current about the PHYT, Heather's growth and expertise has been amazing. Using her weight loss regimen, I was able to lose 25 pounds. After 3 years, I'm still maintaining the weight loss. Her belief, enthusiasm and encouragement in what she does keeps me going. Thank you Heather❤️❤️🙏🏾🙏🏾🔥🔥",
    rating: 5,
  },
  {
    id: 4,
    name: 'Espy Alvarez',
    date: '4 months ago',
    avatar: null,
    content:
      "I feel incredibly fortunate to have met Heather and made the decision to book both group and one-on-one strength training sessions with her. She is not only highly knowledgeable in her practice but also creates a welcoming and empowering environment for women of all fitness levels. Her guidance has helped me build strength and confidence, making every session both effective and inspiring. If you're looking for a trainer who truly supports and uplifts you, Heather is the one!",
    rating: 5,
  },
  {
    id: 5,
    name: 'J S',
    date: '2 months ago',
    avatar: null,
    content:
      "Love love love the Phyt Gym! Been a member since 2021 and got a whole new shape through Coach HT's fitness and diet programs. HT focuses on safety first, making weight training doable for all without injury. I've done both individual coaching and small group training - you can't go wrong with either. Thanks for everything HT!",
    rating: 5,
  },
  {
    id: 6,
    name: 'Raina Gomez',
    date: '2 months ago',
    avatar: null,
    content:
      "Been a client with Heather since 2023! Love the gym and exercises! She gently pushes you to your fullest potential. I feel more strong, flexible, and capable. I'll be a forever client and you should be too!",
    rating: 5,
  },
  {
    id: 7,
    name: 'Ribkah N',
    date: '6 months ago',
    avatar: null,
    content:
      "Heather is INCREDIBLE! If you are even considering booking a 1:1 or group class - do it!!!! I've been working with her for two months and the changes are extraordinary - my mobility, flexibility, and strength have progressed so much, and I continue to feel excited to walk into the phyt gym! Heather truly cares about her clients and is always going to put your safety first and support you in building a strong foundation. She has worked with my mobility issues, concerns, and goals, and the environment is so supportive and fun! Heather is a true gem in Leimert park and I'm incredibly grateful to know and work with her!!!",
    rating: 5,
  },
  {
    id: 8,
    name: 'Sarah Perry',
    date: '1 month ago',
    avatar: null,
    content:
      "Having a great experience with small group training. Heather is knowledgeable and encouraging and she will meet you where you are while still challenging you. Everyone who goes to the gym is friendly and supportive which makes the space welcoming and fun.",
    rating: 5,
  },
  {
    id: 9,
    name: 'La Tanya',
    date: '1 month ago',
    avatar: null,
    content:
      "I reached out to Heather for a small group experience. She was super responsive to my email request. We set up a date for a tour and I was pleased with the set up and her explanation of the class format. I signed up for 2- 4-week sessions and it was challenging and hard early on because I had not consistently exercised in almost a year. Heather was there to correct my form and encourage me to fight and push through the burn and fatigue. I started to feel less tired and I pushed myself to workout on my own. Heather is a beast (in a good way)! And I encourage anyone who is early in their fitness journey to select Heather, becaus will customize a workout to meet you where you are physicall",
    rating: 5,
  }
];

function getInitials(name) {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase();
}

const GoogleSVG = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path fill="#4285f4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
    <path fill="#34a853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
    <path fill="#fbbc05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
    <path fill="#ea4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
  </svg>
);

const GoogleReviews = () => {
  const [open, setOpen] = useState(false);
  const [minimized, setMinimized] = useState(false);
  const [imageErrors, setImageErrors] = useState({});

  const handleImageError = (reviewId) => {
    setImageErrors(prev => ({ ...prev, [reviewId]: true }));
  };

  if (minimized) {
    return (
      <div className="fixed bottom-4 left-4 z-50">
        <button
          onClick={() => setMinimized(false)}
          className="bg-white rounded-lg shadow-md border p-2 hover:shadow-lg transition-all duration-200 opacity-90 hover:opacity-100 flex items-center gap-2"
        >
          <GoogleSVG size={20} />
          <div className="flex items-center">
            <span className="text-orange-500 font-semibold text-sm mr-1">5.0</span>
            <div className="flex items-center">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={12} fill="#fa7d09" color="#fa7d09" className="-ml-0.5" />
              ))}
            </div>
          </div>
        </button>
      </div>
    );
  }

  return (
    <div
      className="fixed bottom-4 left-4 z-50"
      style={{ 
        minWidth: open ? 280 : 180, 
        maxWidth: 320,
        fontSize: '13px'
      }}
    >
      <div
        className="bg-white rounded-lg shadow-md border flex flex-col transition-all duration-300"
        style={{ minHeight: open ? 160 : 60 }}
      >
        {/* Header with minimize button */}
        <div className="flex items-center justify-between p-3 border-b border-gray-100">
          <div 
            className="flex items-center gap-2 flex-1 cursor-pointer"
            onClick={() => setOpen((v) => !v)}
          >
            <GoogleSVG size={16} />
            <div className="flex items-center gap-1">
              <span className="text-orange-500 font-semibold text-lg">5.0</span>
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={12} fill="#fa7d09" color="#fa7d09" className="-ml-0.5" />
                ))}
              </div>
            </div>
            {/* <span className="text-xs text-gray-600 font-medium ml-1">14 reviews</span> */}
            <ChevronDown 
              size={14} 
              className={`text-gray-400 transition-transform duration-200 ml-1 ${open ? 'rotate-180' : ''}`} 
            />
          </div>
          <button
            onClick={() => setMinimized(true)}
            className="p-1 hover:bg-gray-100 rounded transition-colors duration-150"
          >
            <Minus size={12} className="text-gray-400" />
          </button>
        </div>

        {/* Expanded reviews */}
        {open && (
          <div className="px-3 pb-3 pt-2 bg-white max-h-[36rem] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
            {mockReviews.map((review) => (
              <div key={review.id} className="flex gap-2 py-3 border-b last:border-b-0 border-gray-100">
                {review.avatar && !imageErrors[review.id] ? (
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-8 h-8 rounded-full object-cover flex-shrink-0"
                    onError={() => handleImageError(review.id)}
                    onLoad={() => console.log('Image loaded successfully:', review.avatar)}
                  />
                ) : (
                  <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center text-xs font-bold text-white flex-shrink-0">
                    {getInitials(review.name)}
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-semibold text-gray-900 text-xs truncate">{review.name}</span>
                    <span className="text-xs text-gray-500 flex-shrink-0">{review.date}</span>
                    <GoogleSVG size={12} />
                  </div>
                  <div className="flex items-center mb-2">
                    {[...Array(review.rating)].map((_, i) => (
                      <Star key={i} size={10} fill="#000" color="#000" />
                    ))}
                  </div>
                  <div className="text-gray-800 text-xs leading-relaxed">
                    {review.content}
                  </div>
                </div>
              </div>
            ))}
            <div className="pt-3 border-t border-gray-100">
              <a
                href="https://www.google.com/search?newwindow=1&sca_esv=8a70c10f7ae50c33&cs=0&output=search&kgmid=/g/11trh6882y&q=Elyte+Fitness&shndl=30&shem=dlce1,lcuae,lspt14,uaasie&source=sh/x/loc/uni/m1/1&kgs=9c44a1a3843bfff8#lrd=0x2f5131e072e8b89f:0x1bb92c164bd1fc41,1,,,,"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 text-xs font-medium flex items-center gap-1"
              >
                See all 14 reviews on Google
                <svg className="w-3 h-3" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 17L17 7M17 7H8M17 7V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GoogleReviews; 